import OToaster from './OToaster.vue'

OToaster.install = (Vue, options) => {
  Vue.prototype.$otoaster = new (Vue.extend(OToaster))({ propsData: options })
  Vue.$otoaster = Vue.prototype.$otoaster
  if (typeof window !== 'undefined') { window.$otoaster = Vue.prototype.$otoaster }
}

export default OToaster
